module.exports = __webpack_public_path__ + "fonts/SairaCondensed-Bold.d894a25a.ttf";